/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TaskType
 */
export interface TaskType {
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    taskTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    taskTypeNameEn?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    deprecated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    featureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    nameKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    descriptionKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    referenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    releaseDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskType
     */
    isMedicalComponent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    refIcon: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    hashIcon: string;
    /**
     * 
     * @type {string}
     * @memberof TaskType
     */
    $type?: TaskTypeTypeEnum;
}


/**
 * @export
 */
export const TaskTypeTypeEnum = {
    PtwPtw100AppZeroCoreSharedLicenseComponentModelsTaskTypePtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.TaskType, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type TaskTypeTypeEnum = typeof TaskTypeTypeEnum[keyof typeof TaskTypeTypeEnum];



/**
 * Check if a given object implements the TaskType interface.
 */
export function instanceOfTaskType(value?: unknown): value is TaskType {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskTypeTypeEnum)[0];
}

export function TaskTypeFromJSON(json: any): TaskType {
    return TaskTypeFromJSONTyped(json, false);
}

export function TaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskType {
    if (json == null) {
        return json;
    }
    return {
        
        'taskTypeId': json['taskTypeId'] == null ? undefined : json['taskTypeId'],
        'taskTypeNameEn': json['taskTypeNameEn'] == null ? undefined : json['taskTypeNameEn'],
        'deprecated': json['deprecated'] == null ? undefined : json['deprecated'],
        'featureId': json['featureId'] == null ? undefined : json['featureId'],
        'nameKey': json['nameKey'] == null ? undefined : json['nameKey'],
        'descriptionKey': json['descriptionKey'] == null ? undefined : json['descriptionKey'],
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'version': json['version'] == null ? undefined : json['version'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'isMedicalComponent': json['isMedicalComponent'] == null ? undefined : json['isMedicalComponent'],
        'refIcon': json['refIcon'],
        'hashIcon': json['hashIcon'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TaskTypeToJSON(value?: TaskType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskTypeId': value['taskTypeId'],
        'taskTypeNameEn': value['taskTypeNameEn'],
        'deprecated': value['deprecated'],
        'featureId': value['featureId'],
        'nameKey': value['nameKey'],
        'descriptionKey': value['descriptionKey'],
        'referenceNumber': value['referenceNumber'],
        'version': value['version'],
        'releaseDate': value['releaseDate'],
        'isMedicalComponent': value['isMedicalComponent'],
        'refIcon': value['refIcon'],
        'hashIcon': value['hashIcon'],
        '$type': value['$type'],
    });
}

